import { mergePieveWorkflowPatch } from '@shared/pieve/mergePieveWorkflowPatch.js';

const BRANCH_MAP_KEYS = ['branchesByKey', 'branches'];

const patchSteps = (steps, patchByStepId) => {
  if (!Array.isArray(steps)) {
    return steps;
  }

  return steps.map((step) => {
    if (!step || typeof step !== 'object') {
      return step;
    }

    const patches = patchByStepId.get(step.stepId) || [];
    let next = patches.reduce((current, patch) => mergePieveWorkflowPatch({ target: current, patch }), step);

    if (Array.isArray(next.children)) {
      next = { ...next, children: patchSteps(next.children, patchByStepId) };
    }

    for (const key of BRANCH_MAP_KEYS) {
      if (next[key] && typeof next[key] === 'object' && !Array.isArray(next[key])) {
        next = { ...next, [key]: Object.fromEntries(Object.entries(next[key]).map(([branchKey, branchSteps]) => [branchKey, patchSteps(branchSteps, patchByStepId)])) };
      }
    }

    return next;
  });
};

/*
 * The draft as the person sees it: the stored row with each step edit still in flight merged into its step, oldest
 * first, with the same merge the API applies (mergePieveWorkflowPatch). Edits for another workflow are ignored, and a
 * workflow with none comes back as the stored object itself.
 */
const applyWorkflowStepPendingEdits = ({ workflow, pendingEdits = [] } = {}) => {
  const edits = pendingEdits.filter((edit) => edit.workflowId === workflow?.workflowId);

  if (!workflow || edits.length === 0 || !Array.isArray(workflow.definition?.steps)) {
    return workflow;
  }

  const patchByStepId = new Map();

  for (const edit of edits) {
    patchByStepId.set(edit.stepId, [...(patchByStepId.get(edit.stepId) || []), edit.patch]);
  }

  return { ...workflow, definition: { ...workflow.definition, steps: patchSteps(workflow.definition.steps, patchByStepId) } };
};

export default applyWorkflowStepPendingEdits;
